/**
 * useCancelSubscription hook
 *
 * TanStack mutation wrapping `billingApi.cancelSiteSubscription`. Schedules
 * cancel-at-period-end on the active sub.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelSiteSubscription } from '../api/billingApi';

interface CancelResult {
  cancelAt: string;
  message: string;
}

export function useCancelSubscription() {
  const queryClient = useQueryClient();
  return useMutation<CancelResult, Error, string>({
    mutationFn: (siteId) => cancelSiteSubscription(siteId),
    onSuccess: (_, siteId) => {
      queryClient.invalidateQueries({ queryKey: ['sites', siteId] });
      queryClient.invalidateQueries({ queryKey: ['sites', siteId, 'subscription'] });
      queryClient.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
